import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffsWithoutRoleIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionarios/sem/cargo', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  botaoEdicao (cell, row) {
    var url = '/funcionario/editar/' + cell;

    var botao = (
      <Link className={'btn btn-primary btn-sm'} to={url}>
        <i className="fa fa-fw fa-pencil"></i>
      </Link>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.titulo}</h3>
      <Link to="/funcionario/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Tripulantes.ListaDeFuncionariosSemCargo.botaoAdicionarFuncionario}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.semTripulantes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.Nome}</TableHeaderColumn>

        <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.Matricula}</TableHeaderColumn>

        <TableHeaderColumn dataField="role_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.Cargo}</TableHeaderColumn>

        <TableHeaderColumn dataField="license" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.Licenca}</TableHeaderColumn>

        <TableHeaderColumn dataField="canac" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.CANAC}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>{this.locale.Tripulantes.ListaDeFuncionariosSemCargo.tabela.Acoes}</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffsWithoutRoleIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsWithoutRoleIndex.js